import React, { useEffect, useState } from "react";
import "../../../styles/desktop/detalhes.css";
import getImageFromId from "../../../API/events/getImageFromId";

const Detalhes = ({ evento, onClose }) => {
  const [imageData, setImageData] = useState(null); // Estado para armazenar a imagem
  const [isLoading, setIsLoading] = useState(false); // Estado de carregamento da imagem
  const [isPopupOpen, setIsPopupOpen] = useState(false); // Estado para o pop-up

  useEffect(() => {
    const fetchImage = async () => {
      if (evento.imagem_id) {
        setIsLoading(true); // Inicia o carregamento
        try {
          const response = await getImageFromId(evento.imagem_id); // Busca a imagem
          if (response && response.image) {
            setImageData(response.image); // Armazena a imagem
          }
        } catch (error) {
          console.error("Erro ao buscar imagem:", error);
        } finally {
          setIsLoading(false); // Finaliza o carregamento
        }
      }
    };

    fetchImage();
  }, [evento.imagem_id]);

  return (
    <div className="detalhes-container">
      <div className="detalhes-header">
        <h2>Detalhes do Evento</h2>
        <button className="close-button-detalhes" onClick={onClose}>
          Voltar
        </button>
      </div>
      <div className="detalhes-content">
        <div className="detalhes-item">
          <strong>Nome:</strong> {evento.nome}
        </div>
        <div className="detalhes-item">
          <strong>Tipo:</strong> {evento.tipo}
        </div>
        <div className="detalhes-item">
          <strong>Descrição:</strong> {evento.descricao}
        </div>
        <div className="detalhes-item">
          <strong>IP Controlador:</strong> {evento.ip}
        </div>
        <div className="detalhes-item">
          <strong>Data:</strong> {evento.data}
        </div>
        <div className="detalhes-item">
          <strong>Hora:</strong> {evento.hora}
        </div>
        {evento.chamado_detalhes && (
          <div className="detalhes-item">
            <strong>Detalhes do Chamado:</strong> {JSON.stringify(evento.chamado_detalhes, null, 2)}
          </div>
        )}
        {/* Placeholder enquanto carrega ou imagem final */}
        <div className="detalhes-image">
          {isLoading ? (
            <div className="placeholder"></div> // Placeholder animado
          ) : imageData ? (
            <img
              src={imageData}
              alt="Imagem do Evento"
              onClick={() => setIsPopupOpen(true)} // Abre o pop-up ao clicar
            />
          ) : (
            <p></p>
          )}
        </div>
      </div>
      {/* Pop-up da imagem em tela cheia */}
      {isPopupOpen && (
        <div className="image-popup" onClick={() => setIsPopupOpen(false)}>
            <p className="msgImagemEvento">Clique em qualquer lugar para fechar a imagem</p>
            <img src={imageData} alt="Imagem do Evento em Tela Cheia" />
        </div>
      )}
    </div>
  );
};

export default Detalhes;
